import { render, staticRenderFns } from "./OrderDetailModalInfo.vue?vue&type=template&id=4e178c82&scoped=true"
import script from "./OrderDetailModalInfo.vue?vue&type=script&lang=js"
export * from "./OrderDetailModalInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailModalInfo.vue?vue&type=style&index=0&id=4e178c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e178c82",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fcomponents%2Forder%2Forder-detail-modal-info%2FOrderDetailModalInfo.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports